package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.useEffectOnce
import react.useState
import web.cssom.ClassName

internal external interface UpdateAgeGroupPageProps : Props {
    var viewModel: UpdateTrainingViewModel
    var onDone: () -> Unit
}

private data class UpdateAgeGroupContent(val key: AgeGroupKey, val title: String)

private val ageGroupContents = listOf(
    UpdateAgeGroupContent(AgeGroupKey.UNDER_30, "Under 30"),
    UpdateAgeGroupContent(AgeGroupKey.AGE_30_39, "30 - 39"),
    UpdateAgeGroupContent(AgeGroupKey.AGE_40_49, "40 - 49"),
    UpdateAgeGroupContent(AgeGroupKey.AGE_50_64, "50 - 64"),
    UpdateAgeGroupContent(AgeGroupKey.OVER_65, "65 +"),
)

internal val UpdateAgeGroupPage = FC<UpdateAgeGroupPageProps> { props ->
    var selectedAgeGroup by useState(props.viewModel.selectedAgeGroup.value)

    useEffectOnce {
        scope.launch { props.viewModel.selectedAgeGroup.collect { selectedAgeGroup = it } }
    }

    div {
        className = ClassName("wizard-page wizard-page-has-bottom-bar")

        PageTitleSection(
            "Select your age group",
            "Your age group helps us design a yoga program tailored to your physical needs, ensuring safe and effective practice."
        )

        div {
            className = ClassName("wizard-list")
            ageGroupContents.forEach { content ->
                AddTrainingRow(null, content.title, null, selectedAgeGroup == content.key) {
                    props.viewModel.selectAgeGroup(content.key)
                }
            }
        }
    }

    div {
        className = ClassName("wizard-bottom-bar")
        button {
            className = ClassName("outlined-button")
            disabled = selectedAgeGroup == null
            onClick = { props.onDone() }
            +"Done"
        }
    }
}
